import React, { Component, Fragment } from 'react';
import { Button } from 'semantic-ui-react';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';

class ToolboxRightButtons extends Component {
  static defaultProps = {
    buttons: [],
    formName: null,
  };

  //TODO: Add prop-types

  state = {
    showDialog: false,
  };

  renderDefaultSaveButton = () => {
    const { formName, saveButtonProps } = this.props;

    //remove confirmText so don't get warnings
    //calling delete saveButtonProps.confirmText actually mutates the props and then
    //confirmText is not available on saving.
    const { confirmText, ...rest } = saveButtonProps;

    if (formName) {
      return (
        <Fragment>
          <YesNoDialog
            showDialog={this.state.showDialog}
            yesCallback={() => {
              this.setState({ showDialog: false });
              this.props.submitForm(this.props.formName);
            }}
            noCallback={() => {
              this.setState({ showDialog: false });
            }}
            title={'Please confirm.'}
            question={saveButtonProps.confirmText}
          />
          <Button
            primary
            content={'Save'}
            className={'toolbox-button'}
            onClick={this.props.onClick ? this.props.onClick : this.onSaveClick}
            size={'large'}
            {...rest}
          />
        </Fragment>
      );
    }
  };

  onSaveClick = () => {
    const {
      saveButtonProps: { confirmText },
    } = this.props;
    if (confirmText && confirmText.length > 0) {
      this.setState({ showDialog: true });
    } else {
      this.props.submitForm(this.props.formName);
    }
  };

  render() {
    const { formName, buttons } = this.props;

    if (!formName && buttons.length === 0) {
      return null;
    }

    return (
      <span className={'toolbox-controls right'}>
        {buttons.map((button, i) => {
          return (
            <Button
              primary
              className={'toolbox-button'}
              key={`${button.content}${i}`}
              size={'large'}
              {...button}
            />
          );
        })}
        {this.renderDefaultSaveButton()}
      </span>
    );
  }
}

export { ToolboxRightButtons };



// WEBPACK FOOTER //
// ./src/components/toolbox/ToolboxRightButtons.js